const asDate = iso => (iso.length === 10 ? new Date(`${iso}T12:00:00`) : new Date(iso))

const parts = (iso, tz, options) =>
  new Intl.DateTimeFormat('en-US', { timeZone: tz || undefined, ...options }).format(asDate(iso))

export const formatDate = (iso, tz) => parts(iso, tz, { weekday: 'short', month: 'short', day: 'numeric' })
export const formatLongDate = (iso, tz) => parts(iso, tz, { weekday: 'long', month: 'long', day: 'numeric' })
export const shortDay = (iso, tz) => parts(iso, tz, { month: 'short', day: 'numeric' })
export const formatTime = (iso, tz) => parts(iso, tz, { hour: 'numeric', minute: '2-digit' }).replace(/\u202f/g, ' ')

const CLOCK = /^(\d{1,2}):(\d{2})$/

export const formatClock = clock => {
  const match = CLOCK.exec(clock ?? '')
  if (!match) return ''
  const hour = Number(match[1])
  const twelve = hour % 12 || 12
  return `${twelve}:${match[2]} ${hour < 12 ? 'AM' : 'PM'}`
}
